import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
})

/**
 * Clase para ver el request de artículos
 */
class ArticulosRequest {
    /**
     * Llamada el endpoint de django para obtener los artículos
     * en la BD
     * @param: nada
     * @return: Una lista de artículos.
     */
    static ListarArticulos(filtros) {
        let drives = filtros.id_drives !== undefined ? filtros.id_drives.toString() : undefined
        return middleware.hasAuth(() => request.get(`api/articulos/`, {
            params: {
                filtro: filtros.filtro,
                categoria: filtros.categoria,
                id_drives: drives,
                page: filtros.page,
                segmento_id: filtros.segmento_id,
            }
        }))
    }

    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static CategorizarArticulos(value,data) {
        return middleware.hasAuth(() => request.put(`api/articulos/categorizar/${value}/`, data));
    }

    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static CargarProductosCategoria(filtros) {
        return middleware.hasAuth(() => request.get(`api/sitios/estatus/articulos/`, {
            params: {
                filtro: filtros.filtro,
                categoria: filtros.categoria,
                drive_id: filtros.id_drives.toString(),
                page: filtros.page
            }
        }))
    }
}

export default ArticulosRequest;